// extracted by mini-css-extract-plugin
module.exports = {"loginModal":"loginModal-J-R-3","customModal":"customModal-N1xv0"};